import { object, string } from "yup";
import validationMessages from "app/utils/form/validationMessages";

export const defaultValues = {
	booking: "",
	email: "",
};

export const validationSchema = object().shape({
	booking: string().required(validationMessages.bookingReferenceRequired),
	email: string().required(validationMessages.bookingEmailRequired),
});
